import * as React from 'react'
import { I18nService } from '../../../../services/utils/i18n.service'
import { StoreProps } from '../../../../services/stores/casting.store'
import { SelectableIconContainer, SelectableIconText, SelectableIcons, SelectableItem } from '../options/casting-options-picker.component'
import { httpGetAssetPath } from '../../../../services/utils/http.service'
import { lodgingI18nIcalProvider, lodgingI18nIcalValidationError } from '../../../../services/models/lodgings.service'
import { InfoBoxWarning, Input } from '../casting-styled.component'
import LoadingComponent from '../../../shared/loading.component'

const i18nScoped = new I18nService(require('./lodging-ical-content.component.yml'))

export default function LodgingIcalContentComponent ({ store, data: { market, lodgingIcalPlatform, lodging } }: StoreProps) {
  const icalValidationError = store.asyncComputedProperties.icalValidationError.readOrAsyncCompute([!('id' in lodging) ? lodging.ical_url : null])

  const setLodgingPlatform = React.useCallback((lodgingIcalPlatform: 'airbnb' | 'booking' | 'beds24' | 'lodgify' | 'unknown') => {
    store.set({ lodgingIcalPlatform, lodging: { ...lodging, ical_url: '' } })
  }, [lodging, store])

  if (('id' in lodging)) return null

  return <>
    <p>{ i18nScoped.t('choose_platform') }</p>

    <SelectableIcons style={{ padding: 0 }}>
      { (['airbnb', 'booking', 'beds24', 'lodgify', 'unknown'] as const).map(choice => {
        const selected = choice === lodgingIcalPlatform
      
        return <SelectableItem key={ choice }>
          <Input type="checkbox" id={ `lodging-${choice}` } onChange={ () => setLodgingPlatform(choice) } checked={ selected } />
          <label htmlFor={ `lodging-${choice}` } style={{ textAlign: 'center' }}>
            <SelectableIconContainer $selected={ selected }>
              <img src={ httpGetAssetPath(`interface/logo-${choice}.png`) } style={{ opacity: selected ? 1 : 0.7, width: '100%' }} />
            </SelectableIconContainer>
            
            <SelectableIconText $selected={ selected } children={ lodgingI18nIcalProvider(choice) } />
          </label>
        </SelectableItem>
      }) }
    </SelectableIcons>

    { lodgingIcalPlatform && lodgingIcalPlatform !== 'unknown' && <>
      { lodgingIcalPlatform === 'airbnb' && <p>
        <em className='icon-question u-mrs' />
        { i18nScoped.tFragment('airbnb_instructions', { link: <a href={ i18nScoped.t('airbnb_help_url') } target='_blank' rel="noreferrer">{ i18nScoped.t('here') }</a> }) }
      </p> }

      { lodgingIcalPlatform === 'booking' && <div>
        <p><strong>{ i18nScoped.t('booking_instructions') }</strong></p>
        <ol>
          { [1, 2, 3, 4, 5].map(line => <li key={ line } style={{ textAlign: 'justify' }}>{ i18nScoped.t('booking_instructions_' + line) }</li>) }
        </ol>

        <InfoBoxWarning style={{ marginBottom: '1em' }}>{ i18nScoped.t('booking_warning') }</InfoBoxWarning>
      </div> }

      { lodgingIcalPlatform === 'beds24' && <p style={{ textAlign: 'justify' }}>
        <em className='icon-question u-mrs' /> { i18nScoped.t('beds24_instructions') }
      </p> }

      { lodgingIcalPlatform === 'lodgify' && <p style={{ textAlign: 'justify' }}>
        <em className='icon-question u-mrs' /> { i18nScoped.t('lodgify_instructions') }
      </p> }

      <Input
        id='js-test-lodging-ical-url'
        type='url'
        placeholder={ i18nScoped.t('ical_url_placeholder') }
        value={ lodging.ical_url }
        onChange={ e => store.set({ lodging: { ...lodging, ical_url: e.target.value.trim() } }) } />

      { lodging.ical_url && <>
        { !icalValidationError && <LoadingComponent 
          presentation="inline" 
          message={ i18nScoped.t('validating_ical_url') } 
          loadingIconStyle={{ display: 'inline-block', height: '2em' }} 
        /> }

        { icalValidationError && <div className= { `u-gridInline-flexStart u-alignMiddle ${icalValidationError !== 'valid' ? 'u-txtClrError' : 'u-txtClrSuccess'}` }>
          <i className={ icalValidationError !== 'valid' ? 'icon-error' : 'icon-check' }></i>&nbsp;
          <span className="u-mlxs">{ lodgingI18nIcalValidationError(icalValidationError) }</span>
        </div> } 
      </> }
    </> }

    { lodgingIcalPlatform === 'unknown' && <p style={{ textAlign: 'justify' }}>
      { i18nScoped.tFragment('this_provider_is_not_yet_implemented_contact_us', { email: <a href={ `mailto:${market.contact_email}` }>{ market.contact_email }</a> }) }
    </p> }
  </>
}
